import { FC } from 'react'

import { RenderIf } from 'components/RenderIf'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useGetTranslatedNames } from 'featureSliced/shared/hooks/useGetTranslatedNames'
import { convertToPrice } from 'featureSliced/shared/utils/convertToPrice'
import { collectFixedItems } from 'featureSliced/shared/utils/menuStepChoices'

import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

import {
  IncludedList,
  IncludedName,
  IncludedPrice,
  IncludedRow,
  IncludedTitle,
} from './styled'

type FixedTemplateItemsProps = {
  product: IProduct
}

/**
 * What the template attaches on its own, named before the guest adds the product.
 * The price shown is per article, not per basket line — the head price above
 * multiplies with the stepper, this does not (Pavel, QRM-665).
 */
export const FixedTemplateItems: FC<FixedTemplateItemsProps> = ({
  product,
}) => {
  const t = useTranslations()
  const { getProductName } = useGetTranslatedNames()
  const Currency = useMySelector((state) => state.app.companyData.Currency)

  const fixedItems = collectFixedItems(product?.menus)

  return (
    <RenderIf condition={fixedItems.length > 0}>
      <div data-testid="fixed-template-items">
        <IncludedTitle>{t('products.included')}</IncludedTitle>
        <IncludedList>
          {fixedItems.map(({ item, menuIndex }) => {
            const count = Number(item.count) || 1
            const price = (Number(item.price) || 0) * count
            return (
              <IncludedRow key={`fixed-item_${menuIndex}_${item.id}`}>
                <IncludedName>
                  {count > 1 ? `${count} × ` : ''}
                  {getProductName(item)}
                </IncludedName>
                <RenderIf condition={price > 0}>
                  <IncludedPrice>
                    +{convertToPrice(price)}&thinsp;{Currency || ''}
                  </IncludedPrice>
                </RenderIf>
              </IncludedRow>
            )
          })}
        </IncludedList>
      </div>
    </RenderIf>
  )
}
